import { array, number, object } from "yup";

export type ConstructionItemSetting = {
	companyMasterId: number;
	constructionItemId: number;
	id: number;
	unitAmount: number | null;
	vendorCompanyId: number;
};

export type ConstructionItemSettingEdit = Omit<
	ConstructionItemSetting,
	"companyMasterId" | "vendorCompanyId" | "id"
>;

export const validationSchemaConstructionItemSettingForm = object().shape({
	settings: array().of(
		object().shape({
			unitAmount: number()
				.transform((value: string) => (Number.isNaN(value) ? null : value))
				.nullable()
				.required("入力してください")
		})
	)
});
